import React from 'react';
import { Link } from 'react-router-dom';
import CpmVsCpsSection from '@/components/sections/CpmVsCpsSection';

const plans = [
  {
    name: 'PILOT',
    tagline: 'For brands validating R360 against their current stack.',
    price: 'CPS 2.8%',
    priceNote: '(negotiable)',
    features: [
      'One vertical, one geo',
      'Single-tag install',
      'Dynamic creative included',
      '60-day performance guarantee',
      'Bi-weekly optimization review',
    ],
    cta: 'Start a pilot',
    highlight: false,
  },
  {
    name: 'GROWTH',
    tagline: 'Most enterprise brands start here. Multi-market ready.',
    price: 'CPS 2.2–2.6%',
    priceNote: 'on verified sale',
    features: [
      'Up to 8 markets / languages',
      'Full DCO engine + unlimited variants',
      'Intent AI with 100+ variables',
      'Dedicated adtech strategist',
      'Weekly attribution reviews',
      'GDPR + CCPA audit included',
    ],
    cta: 'Book a strategy call',
    highlight: true,
  },
  {
    name: 'GLOBAL',
    tagline: 'For multi-region brands running $500K+/mo in paid media.',
    price: 'Custom CPS',
    priceNote: 'volume-tiered',
    features: [
      'Unlimited markets & SKUs',
      'Private DSP seat (TTD / DV360 / Xandr)',
      'Co-located creative pod',
      'Custom intent-model training',
      'SLA-backed reporting API',
      'SOC 2 Type II deliverables',
    ],
    cta: 'Talk to sales',
    highlight: false,
  },
];

const faq = [
  { q: 'What exactly am I paying for?', a: 'A flat percentage of revenue from verified sales that our retargeting closes. No fee on impressions, clicks, visits, or assisted conversions unless explicitly agreed.' },
  { q: 'Is there a minimum budget?', a: 'No. The floor is your recoverable volume — we don’t take accounts we can’t move the needle on, and we don’t gate on media spend.' },
  { q: 'How are sales verified?', a: 'Server-side postback + client tag reconciliation. Duplicate orders are de-deduped. Refunds clawed back automatically.' },
  { q: 'Who owns the creative?', a: 'You do. Every variant our DCO engine produces is yours to keep, export, and re-use on any channel.' },
  { q: 'What happens if performance dips?', a: 'The 60-day guarantee kicks in: if we don’t deliver measurable ROAS lift, you pay nothing — and we run the next month at zero cost to prove the model.' },
  { q: 'How quickly can we get started?', a: 'You can be live in as little as 48 hours—guaranteed. Our team manages the full setup, tracking integration, and campaign launch, so you start recovering lost revenue fast.' },
];

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <section className="pt-20 pb-16 border-b border-[#1a1a1a] hero-grid diag-lines inner-hero">
        <div className="container-r360">
           <div className="highlights-kicker text-blue">
            <span />
           PRICING || CPS MODEL
          </div>
          <h1 className="font-display font-bold leading-[0.92] tracking-[-0.035em] text-[70px] sm:text-[4rem] md:text-[5.5rem] lg:text-[6.5rem]">
            PAY ONLY ON <span className="accent">VERIFIED SALE.</span><br />NOTHING ELSE.
          </h1>
          <p className="text-[17px] text-[#c9c9c9] font-bold leading-relaxed mt-4 max-w-6xl">
            Every dollar you invoice with Retarget360 is tied to a confirmed revenue event. No impressions. No clicks. No minimums.
            No long-tail attribution disputes. The only risk left is how fast you scale.
          </p>
        </div>
      </section>

      {/* <section className="highlights-section">
        <div className="container-r360">
          <div className="grid grid-cols-1 lg:grid-cols-3 border-t border-l border-[#1a1a1a]">
            {plans.map((p) => (
              <div
                key={p.name}
                className={`border-r border-b border-[#1a1a1a] p-8 bg-white/70 flex flex-col ${p.highlight ? 'relative' : ''}`}
                data-testid={`plan-${p.name.toLowerCase()}`}
              >
                {p.highlight && (
                  <span className="absolute top-0 right-0 bg-[#00e0ff] font-extrabold font-sans text-[11px] px-3 py-1 tracking-widest">
                    MOST POPULAR
                  </span>
                )}
                <div className="text-[1rem] font-bold accent mb-4">{p.name}</div>
                <div className="font-display text-[40px] font-black leading-none">{p.price}</div>
                <div className="mono-label mt-3 text-green font-black">{p.priceNote}</div>
                <p className="text-[1rem] font-medium leading-relaxed mt-4">{p.tagline}</p>
                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f, i) => (
                    <li key={i} className="flex gap-3 text-[14px] text-[#1a1a1a]">
                      <span className="text-[1.25rem] text-[#ff5117]">✓</span>
                      <span className='text-[1rem] font-medium'>{f}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to="/book-a-demo"
                  className={`mt-8 ${p.highlight ? 'btn btn-primary' : 'btn btn-outline-alt'}`}
                  data-testid={`plan-cta-${p.name.toLowerCase()}`}
                >
                  {p.cta} →
                </Link>
              </div>
            ))}
          </div>
          <div className="mt-10 flex flex-col md:flex-row items-start md:items-center gap-3">
            <span className="text-[#00e0ff] text-xl">▲</span>
            <div className="text-[14px] font-bold leading-relaxed">
              All plans include the 60-day performance guarantee, single-tag install, creatives, full-funnel attribution, and a fully managed optimization team.
            </div>
          </div>
        </div>
      </section> */}

      <section className="py-24 border-t border-[#1a1a1a] highlights-section">
        <div className="container-r360">
          <div className="highlights-kicker">
            <span />Pay For what you get
          </div>
        
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <h2 className="reveal-on-scroll lg:col-span-6 font-display text-[3.75rem] sm:text-[4.5rem] lg:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
            If We Miss,  <span className="accent"><br />You Don’t Pay.</span>
          </h2>
          <div className="lg:col-span-6">
             <div className="reveal-on-scroll lg:col-span-6 space-y-5 text-[16px] leading-relaxed">
              <p className='sec-subhead'>
                If Retarget360 doesn’t deliver measurable ROAS lift within the first 60 days of your contract, we zero out the bill —
                and run your next month’s campaign at <span className="italic">zero cost</span> to prove the model.No small print. No asterisk. Just a team that refuses to invoice for work that didn’t move revenue.
              </p>
               <div className="flex flex-wrap gap-4 mt-8">
                    <Link to="/book-a-demo" className="btn btn-primary mb-2" data-testid="pricing-book">Book a strategy call →</Link>
                    <Link to="/calculator" className="btn btn-outline-alt mb-2">Run the ROAS calculator</Link>
                </div>
            
            </div>
          </div>
        </div>
       
     
        </div>
      </section>

      <CpmVsCpsSection />

     

      <section className="highlights-section">
        <div className="container-r360">
          <div className="highlights-kicker">
            <span />Frequently Asked Questions
          </div>
           <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.75rem] sm:text-[4.5rem] lg:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626]">
            What <span className="accent">CMOs</span> Ask First
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border-t border-l border-[#1a1a1a] mt-10">
            {faq.map((f, i) => (
              <div key={i} className="border-r border-b border-[#080808] p-6 bg-white/40">
                <div className="font-display text-[20px] font-bold mb-3 accent">{f.q}</div>
                <p className="text-[15px] font-sans font-medium  text-[#262626] leading-relaxed">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
